var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Wrapper',[_c('div',{ref:"autoShiftLoading",staticClass:"auto-shift-loading-icon"}),_c('div',{staticClass:"auto-shift-loading-title"},[_vm._v("自動入力中です。")]),_c('div',{staticClass:"auto-shift-loading-explanation"},[_vm._v("自動入力中は操作できません。このままお待ち下さい。"),_c('br'),_vm._v("自動入力されたシフトは水色で表示されます。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }